import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

import fr from 'vuetify/es5/locale/fr'

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#01ADED',
        secondary: '#EA008B',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg',
  },
  lang: {
    locales: { fr },
    current: 'fr',
  },
})